<template>
  <div class="home">
    <Header/>
    <div class="content-box">

     <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide><img style="width:100%" src="../assets/image/course/banner@2x.png"></swiper-slide>
      <swiper-slide><img style="width:100%" src="../assets/image/course/banner@2x.png"></swiper-slide>
      <swiper-slide><img style="width:100%" src="../assets/image/course/banner@2x.png"></swiper-slide>
      <swiper-slide><img style="width:100%" src="../assets/image/course/banner@2x.png"></swiper-slide>
      <div class="swiper-pagination"  slot="pagination"></div>
  </swiper>

  <div style="width:100%;text-align:center;padding-top:50px;padding-bottom:50px;">
    <img style="height:43px;" src="../assets/image/course/img1.png"/>
  </div>

    <div class="model_div">
          <img class="model_img" src="../assets/image/course/一对一@2x.png"/>
          <img class="model_img" src="../assets/image/course/小组课@2x.png"/>
          <img class="model_img" src="../assets/image/course/在线课程@2x.png"/>
          <img class="model_img" src="../assets/image/course/全日制@2x.png"/>
          <img class="model_img" src="../assets/image/course/艺考集训@2x.png"/>
    </div>



    <div class="box3">
      <img style="height:800px;" src="../assets/image/course/传授知识@2x.png"/>
    </div>

  <div style="width:100%;text-align:center;padding-top:50px;padding-bottom:50px;">
    <img style="height:43px;" src="../assets/image/course/标题@2x.png"/>
  </div>
<div class="model_div">
          <img class="model_img" src="../assets/image/course/全程跟踪反馈@2x.png"/>
          <img class="model_img" src="../assets/image/course/个性化定制方案 拷贝 2@2x.png"/>
          <img class="model_img" src="../assets/image/course/科学匹配师资@2x.png"/>
          <img class="model_img" src="../assets/image/course/定期诊断反馈@2x.png"/>
          <img class="model_img" src="../assets/image/course/1对1贴心服务@2x.png"/>
          <img class="model_img" src="../assets/image/course/配套升学规划@2x.png"/>
    </div>

    <div class="box4">
      <img style="height:100%;width:100%" src="../assets/image/course/升学通路规划@2x (2).png"/>
    </div>
    <div class="box5">
      <img style="height:100%;width:100%;margin-top:60px;margin-bottom:70px;" src="../assets/image/course/PDCA教学模型@2x.png"/>
    </div>
    <div class="box6">
        <div class="box6_1" style="text-align:center">
          <img style="height:43px;margin-top:50px;" src="../assets/image/course/标题@2x(1).png"/>
        </div>
        <img class="img3" src="../assets/image/course/img3.png"/>
    </div>
   
   <div style="width:100%;text-align:center;padding-top:50px;padding-bottom:50px;">
    <img style="height:43px;" src="../assets/image/course/标题@2x(2).png"/>
  </div>
<div class="model_div_haopin haopin">
          <img style="height:655px;" src="../assets/image/course/右侧成绩 @2x.png"/>
    </div>


<div class="model_div_haopin">
          <img style="height:655px;" src="../assets/image/course/四大承诺@2x.png"/>
    </div>

    <div class="home-footer">

    <div style="width:100%;text-align:center;padding-top:50px;padding-bottom:50px;">
    <img style="height:43px;" src="../assets/image/course/标题@2x(3).png"/>
  </div>

<div class="model_div">
          <img class="model_img" src="../assets/image/course/最具影响力教育品牌@2x.png"/>
          <img class="model_img" src="../assets/image/course/优秀组织奖@2x.png"/>
          <img class="model_img" src="../assets/image/course/校外基础教育培训机构@2x.png"/>
          <img class="model_img" src="../assets/image/course/团队优胜单位@2x.png"/>
          <img class="model_img" src="../assets/image/course/鹏程杯@2x.png"/>
          <img class="model_img" src="../assets/image/course/最佳朗读@2x.png"/>
          <img class="model_img" src="../assets/image/course/理事单位@2x.png"/>
    </div>

      

      <div class="real" style="margin-top:30px;">

        <div class="nav-footer-container">
        <div class="imgs">
          <img src="../assets/image/logo@2x.png" alt="竞争力">
          <div class="first">蓝天教育集团旗下个性化教育品牌</div>
          <div>十余年一对一个性化教育经验</div>
          <div>深耕本土学情考情</div>
          <div>服务深圳万千学子</div>
        </div>
        <div class="code">
          <img src="../assets/image/v2_qt4piy@2x.png" alt="">
          <p>扫码关注服务号</p>
        </div>
        <div class="code">
          <img src="../assets/image/v2_qt4plq@2x.png" alt="">
          <p>扫码关注视频号</p>
        </div>
        <div class="code">
          <img src="../assets/image/v2_qt4pj2@2x.png" alt="">
          <p>扫码关注资讯号</p>
        </div>
        <div class="concat-tel">
          <div class="rex">咨询热线：</div>
          <div class="tel"><img src="../assets/image/page4.png" alt="">0755-83521521</div>
          <div class="time">周一至周日：9:00-22:00</div>
          <div class="btn">在线咨询老师</div>
        </div>
      </div>
  </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@/components/header.vue'

export default {
  data() {
    return {
      queryInfo:{
        currentNav: 1
      },
      swiperOptions: {
        loop : true,
         clickable: true,  
       // swiper configs 所有的配置同swiper官方api配置
       autoplay: {
          disableOnInteraction: false, // 打断后继续自动轮播
          delay: 3000 // 轮播延迟
       },
       pagination: {
          el: '.swiper-pagination',
          // 设置点击可切换
          clickable: true
        },
      }
    }
  },
  components: {
    Header
  },
  computed: {
   swiper() {
      return this.$refs.mySwiper.swiper
   }
  },
   mounted() {
    this.swiper.slideTo(1,1000, false)
 },
  methods:{
      goNav(num){
         this.queryInfo.currentNav = num
      }
  }
}
</script>
<style>
.swiper-pagination-bullet {
  margin: 0 10px;
  background: #fff;
  border-radius: 50%;
}
.swiper-pagination {
  bottom: 10px;
  left: 50%;
  margin-left: -56px;
}
</style>

<style lang="less" scoped>
  .model_div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 70px;
  }
  .model_div_haopin {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
  }
  .haopin {
    padding-top: 100px;
    background: url("../assets/image/course/img5.png") no-repeat;
  }
  .model_div_cert {
    padding-top: 100px;
    background: url("../assets/image/course/图层 639@2x.png") no-repeat;
  }
  .model_img {
    width: 327px;;
  }

  .box6 {
    width: 100%;
    height: 1000px;
    .box6_1{
      background: url("../assets/image/course/img2.png") no-repeat;
      height: 445px;
    }
    .img3 {
      height: 800px;
      position: relative;
      top:-25%;
      left: 30%;
    }
  }

  .box3 {
    width: 100%;
    img {
      width: 100%;
    }
  }

  .swiper-container {
      width: 100%;
      position: relative;
      overflow: hidden;

      .swiper-slide {
        width: 100%;
        // padding-bottom: 28.1%;
        // background-size: cover;
        // background-position: center center;
        // background-repeat: no-repeat;

        /* Center slide text vertically */
        // display: -webkit-box;
        // display: -ms-flexbox;
        // display: -webkit-flex;
        // display: flex;
        // -webkit-box-pack: center;
        // -ms-flex-pack: center;
        // -webkit-justify-content: center;
        // justify-content: center;
        // -webkit-box-align: center;
        // -ms-flex-align: center;
        // -webkit-align-items: center;
        // align-items: center;
      }

      .swiper-pagination{
        .swiper-pagination-bullet-active{
          background-color: #F29B76;
        }
      }
    }

  .fl{
    float: left
  }
  .fr{
    float: right
  }
  .content-box {
    width: 100%;
    .logo {
      margin: 0 auto 21px;
      img {
        width: 100%;
      }
    }

    .pointer {
      cursor:pointer;
    }
  }
  .home-footer {
    width: 100%;
    height: 1100px;
    background: linear-gradient(0deg, #001731, #0D1241, #073371, #4281D9);
    .real {
      display: flex;
    align-items: center;
    justify-items: center;
    }
  }

.nav-footer-container {
    width: 62%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0 auto;
    .imgs {
      width: 270px;
      img {
        width: 100%;
      }
      div {
        &.first {
          margin-top: 14px;
        }
        font-size: 16px;
        color: #fff;
        text-align: left;
        line-height: 28px;
      }
    }
    .code {
      font-size: 18px;
      color: #737479;
      img {
        width: 144px;
      }
      p {
        font-size: 16px;
        color: #fff;
        margin: 17px 0 0;
      }
    }
    .concat-tel {
      .rex {
        font-size: 25px;
        color: #fff;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .tel {
        font-size: 28px;
        color: #fff;
        font-weight: 500;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        img {
          width: 46px;
          margin-right: 10px;
        }
      }
      .time {
        font-size: 23px;
        font-weight: 300;
        color: #fff;
      }
      .btn {
        width: 167px;
        border-radius: 18.3px;
        line-height: 36.6px;
        text-align: center;
        font-size: 21px;
        font-weight: 500;
        color: #1361CF;
        background-color: #fff;
        margin: 24px 0 0 36px;
      }
    }
  }

</style>
